/**
 * Registrierung des Service Workers im Browser.
 */

export function istServiceWorkerUnterstuetzt(): boolean {
  return typeof window !== 'undefined' && 'serviceWorker' in navigator
}

export async function registriereServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (!istServiceWorkerUnterstuetzt()) {
    return null
  }
  try {
    const reg = await navigator.serviceWorker.register('/sw.js', { scope: '/' })
    return reg
  } catch (err) {
    // Fehler bei der Registrierung fangen, damit die App trotzdem normal läuft
    console.warn('Service Worker Registrierung nicht erfolgreich:', err)
    return null
  }
}

export async function holeAktiveRegistrierung(): Promise<ServiceWorkerRegistration | null> {
  if (!istServiceWorkerUnterstuetzt()) {
    return null
  }
  try {
    return (await navigator.serviceWorker.getRegistration('/')) ?? null
  } catch {
    return null
  }
}
